// export const environment = {
//   production: false,
//   baseUrl: 'https://api.knockvia.com/',
//   baseUrlMarketing: 'https://marketing.knockvia.com/',
//   chatServiceUrl: 'https://chat.knockvia.com',
//   licenseKeyPin: 'QS4lJvSxivcCgdgjhjQ1uMYTj9RZEi',
//   licenseKeyFidium: 'AzCgE84EryiR5i2AIJu6bn0GSftlaI',
//   licenseKeyPay: '5uMmC0x6eD2oZwW8iFgY0ICD4i3JEp',
//   licenseKeyUpdate: 'b9vppRCLxJBjeEOGH8cuTB599OlsIP',
//   licenseKeyCreate: '5Ic3Qk9qooZx1IkO27PNn2PA296wH6',
//   licenseKeyMockPay: 'bhbsoCDW9JWn2ju2KlLehPiFx6Kgd3',
//   licenseKeyPendingPay: 'ln1E1FCevhG0pcO0BMGYH7kzs2EbTy',
//   licenseKeyPayHierarchy: 'xWUERg5jzWOo7SQYueNHcuJZ59Ai9x',
//   licenseKeyDishUpdate: 'i43fZAOJRZLCcVrQz07dEEhS4Dvxi1',
//   licenseKeyProviderPayPlan: 'WpLwOZDSZwu3Cqi2UDSA1f28MmoGWJ',
//   adjustmentKey: 'Y6JYBybYv3QRJ8IKMrXo5FnxYkjZzl',
//   mapbox: {
//     accessToken: 'pk.eyJ1IjoiY29kZXNwaGVyZSIsImEiOiJjbWJqc2czajAwa2RkMm1vZnFyNHF2cWY0In0.junIXaF0PYT-zH_yQ3vGNg'
//   },
//   mapsKey: 'AIzaSyApfeC0t3HlpE0YVhwABdfnUTpN9tzED94',
//   fidiumUrl: 'https://api.fidiumscout.com/',
//   showPayroll: true
// };

export const environment = {
  production: false,
  baseUrl: 'https://dev-api.knockvia.com/',
  // baseUrl: 'http://localhost:8443/',
  baseUrlMarketing: 'http://localhost:6969/',
  licenseKeyPin: 'QS4lJvSxivcCgdgjhjQ1uMYTj9RZEi',
  licenseKeyFidium: 'AzCgE84EryiR5i2AIJu6bn0GSftlaI',
  licenseKeyPay: '5uMmC0x6eD2oZwW8iFgY0ICD4i3JEp',
  licenseKeyUpdate: 'b9vppRCLxJBjeEOGH8cuTB599OlsIP',
  licenseKeyCreate: '5Ic3Qk9qooZx1IkO27PNn2PA296wH6',
  licenseKeyMockPay: 'bhbsoCDW9JWn2ju2KlLehPiFx6Kgd3',
  licenseKeyPendingPay: 'ln1E1FCevhG0pcO0BMGYH7kzs2EbTy',
  licenseKeyPayHierarchy: 'xWUERg5jzWOo7SQYueNHcuJZ59Ai9x',
  licenseKeyProviderPayPlan: 'WpLwOZDSZwu3Cqi2UDSA1f28MmoGWJ',
  licenseKeyDishUpdate: 'i43fZAOJRZLCcVrQz07dEEhS4Dvxi1',
  adjustmentKey: 'Y6JYBybYv3QRJ8IKMrXo5FnxYkjZzl',
  mapbox: {
    accessToken: 'pk.eyJ1IjoiY29kZXNwaGVyZSIsImEiOiJjbWJqc2czajAwa2RkMm1vZnFyNHF2cWY0In0.junIXaF0PYT-zH_yQ3vGNg'
  },
  // mapbox: {
  //   accessToken: 'pk.eyJ1IjoiY29kZXNwaGVyZSIsImEiOiJjbW11dmQyYnIwZ2V1Mm9vYXVvcjMwMjlvIn0.ca3ve1qVJCVA6O3sTNx6PQ'
  // },
  mapsKey: 'AIzaSyApfeC0t3HlpE0YVhwABdfnUTpN9tzED94',
  chatServiceUrl: 'https://dev-chat.knockvia.com',
  fidiumUrl: 'https://dev-api.fidiumscout.com/',
  showPayroll: true
};
